<template>
    <div class="input-helpers" v-if="list.length">
        <div
            class="input-helpers__el"
            v-for="(el, key) in list"
            :key="key"
            @click="$emit('inputHelpersChange', {
                    name: inputName,
                    value: el
                })">
            {{ el.value }}
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'InputHelpers',
    props: {
        inputValue: {
            type: String,
            default: ''
        },
        inputName: {
            type: String
        },
        showHelpers: {
            default: false
        },
        coords: {
            default: () => {}
        }
    },
    data() {
        return {
            list: [],
            timeoutRequest: false
        };
    },
    methods: {
        async getHelpers(value) {
            if (!this.timeoutRequest && value.length > 4) {
                this.timeoutRequest = true;

                await setTimeout(() => (this.timeoutRequest = false), 1500);

                axios({
                    url: '/api/2.0/dadata/suggests/',
                    method: 'post',
                    data: {
                        query: value
                    }
                }).then(response => {
                    this.list = response.data.data;
                });
            }
            else {
                this.list = []
            }
        },
        getAddressWithPosition(coord) {
            if (coord.lat && coord.lon) {
                axios({
                    url: '/api/2.0/dadata/geolocate/',
                    method: 'post',
                    data: coord
                }).then(response => {
                    this.$emit('inputHelpersChange', {
                        name: this.inputName,
                        value: response.data.data[0].value
                    });
                });
            }
        }
    },
    watch: {
        inputValue: function() {
            this.getHelpers(this.inputValue);
        },
        coords: function() {
            this.getAddressWithPosition(this.coords);
        }
    }
};
</script>
<style lang="scss">
.input-helpers {
    display: none;
    position: absolute;
    flex-direction: column;
    padding: 10px 0px;
    z-index: 5;
    background: #fff;
    left: 0px;
    border-radius: 8px;
    box-shadow: 4px 4px 4px #efefef, -4px -4px 4px #f7f7f7;

    &:hover {
        display: flex;
    }

    &__el {
        padding: 5px 15px;
        cursor: pointer;

        &:hover {
            background: #ddd;
        }
    }
}

input:focus + label + .input-helpers {
    display: flex;
}
</style>
